'use strict';

var cart = require('../cart/cart');
var breakpoints = require('../components/breakpoints');
var debounce = require('lodash/debounce');
var utils = require('../utils');
var quickView = require('../product/quickView');
var focusHelper = require('../components/focus');
var promoProgressBar = require('brand_core/components/promoProgressBar');

var updateMiniCart = true;
var lastFocusedElement = null; // Store the element that triggered the minicart

function increaseMiniCart() {
    $('.minicart-flyout').addClass('expanded');
}

function decreaseMiniCart() {
    $('.minicart-flyout').removeClass('expanded');
}

function updateShadows() {
    var $cartBody = $('.minicart-flyout .cart-sheet');
    var $cartHeader = $('.minicart-flyout .cart-header-wrapper');
    var $cartFooter = $('.minicart-footer');
    if ($cartHeader.length && $cartFooter.length && $cartBody.length) {
        var scrollTop = $cartBody.scrollTop();
        var maxScroll = $cartBody[0].scrollHeight - $cartBody.innerHeight();
        $cartHeader.toggleClass('scrolled', scrollTop > 0);
        $cartFooter.toggleClass('scrolled', scrollTop < maxScroll);
    }
}
var debounceShadows = debounce(updateShadows, 50);

var loadAppleExpress = function () {
    var expressPaymentsExport = require('../adyen_checkout/expressPaymentsExport');
    expressPaymentsExport.init();
};
module.exports = function () {
    cart();

    // /**
    //  * Wait until a CSS transition has finished
    //  *
    //  * @param {jQuery} $el – the element watching for
    //  * @param {Function} cb – called once the transition is done (or retries exhausted)
    //  * @param {number} tries – amount of times to retry (initially 10)
    //  * @param {number} delayMs – milliseconds between retries (100)
    //  * @returns {Function} - returns callbacl function
    //  */
    // function waitForTransitionEnd($el, cb, tries = 20, delayMs = 100) {
    //     if (!$el.hasClass('is-transitioning') || tries <= 0) {
    //         // no transition in progress, invoke callback immediately
    //         return cb();
    //     }
    //     // otherwise, wait a bit and try again
    //     return setTimeout(() => {
    //         waitForTransitionEnd($el, cb, tries - 1, delayMs);
    //     }, delayMs);
    // }

    function closeMiniCart() {
        if ($('.minicart-flyout').hasClass('show') && !$('.modal-content').is(':visible')) {
            // Store reference before animations start
            var elementToFocus = lastFocusedElement || $('.minicart-link')[0];

            setTimeout(() => {
                $('.minicart-overlay').hide(); // use hide to avoid fadeOut queueing
                $('.minicart-flyout').removeClass('show');
                $('body').removeClass('no-scroll');
                decreaseMiniCart();
                if ($('.remove-product.dismiss-btn:visible').length) {
                    $('.remove-product.dismiss-btn:visible').trigger('click');
                }
                $('body').toggleClass('hide-zendesk', false);
                // Update aria-expanded state
                $('.minicart-link').attr('aria-expanded', 'false');
                // Restore aria-hidden on background content
                $('#maincontent, .page > footer, .footer').attr('aria-hidden', 'false');

                // Restore focus to the button that opened the minicart
                setTimeout(() => {
                    if (elementToFocus && $(elementToFocus).is(':visible')) {
                        $(elementToFocus).focus();
                    }
                    lastFocusedElement = null;
                }, 100);
            }, 300);
        }
    }

    function syncProgressBarWidth() {
        if ($('.free-shipping-indicator .progress-bar').length) {
            setTimeout(function () {
                $('.free-shipping-indicator .progress-bar').each(function () {
                    var $bar = $(this);
                    var valueNow = $bar.attr('aria-valuenow');
                    var numericValue = parseFloat(valueNow) || 0;
                    $bar.css('width', numericValue + '%');
                    if ($('.freeShippingThresholdMessage') === 100) {
                        $('.freeShippingThresholdMessage').addClass('brand-darker-gray');
                    }
                });
                $('.freeShippingThresholdMessage').each(function () {
                    var $message = $(this);
                    var remainMsgNow = $message.data('remain-msg-now'); // Get the value of data-remain-msg-now
                    if (remainMsgNow && !$message.text().includes(remainMsgNow)) {
                        $message.addClass('fade').fadeOut(200, function () {
                            // Update the text and then fade-in
                            $message.text(remainMsgNow).fadeIn(200).removeClass('fade');
                        });
                    }
                });
            }, 700);
        }
    }

    // Minicart button initialization - no href needed for button element

    $(document).on('count:update', '.minicart', function (event, count) {
        var quantityTotal = count.numItems || count.quantityTotal || 0;
        if (count && $.isNumeric(quantityTotal)) {
            var quantityTotalNoBonus = 0;
            var items = [];
            if (count && count.items) {
                items = count.items;
            } else if (count && count.cart && count.cart.items) {
                items = count.cart.items;
            }
            if (items.length) {
                items.forEach(function (item) {
                    quantityTotalNoBonus += +item.quantity;
                    if (item.appliedPromotions && item.appliedPromotions.length) {
                        item.appliedPromotions.forEach(function (promotion) {
                            if (promotion.hideBonus) {
                                quantityTotalNoBonus -= 1;
                            }
                        });
                    }

                    if (item.id === 'embroidery-fee-service') {
                        quantityTotalNoBonus -= item.quantity;
                    }
                });
            }

            $('.minicart .minicart-quantity').text(quantityTotalNoBonus < 100 ? quantityTotalNoBonus : 99);
            if (quantityTotal > 0) {
                $('.minicart-quantity').removeClass('no-quantity-items');
                $('.minicart-flyout').removeClass('empty-cart');
            } else {
                $('.minicart-quantity').addClass('no-quantity-items');
                if (!count.isFake) $('.minicart-flyout').addClass('empty-cart');
            }
            var currentExpanded = $('.minicart .minicart-link').attr('aria-expanded') || 'false';
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems,
                'aria-expanded': currentExpanded
            });

            if (quantityTotal >= 0 && $('.sub-total-label').length) {
                var itemLabel = quantityTotal === 1
                    ? $('.sub-total-label').data('item')
                    : $('.sub-total-label').data('items');

                var updatedLabel = itemLabel.replace('#', quantityTotal);
                $('.sub-total-label').html(updatedLabel);
            }
        }
    });

    $('body').on('click', '.minicart-link', function (e) {
        e.preventDefault();
    });

    $('body').on('click keydown', '.js-close-mini-cart, .minicart-overlay', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }
        e.preventDefault();
        closeMiniCart();
    });

    $('body').on('keydown', '.line-item-name', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            window.location.href = $(this).attr('href');
        }
    });

    var touchStartY = 0;

    function toggleFlyout(e) {
        var touchEndY = e.originalEvent.touches[0].clientY;
        var $minicartFlyout = $('.minicart-flyout');

        if (touchEndY - touchStartY > 50 && $minicartFlyout.hasClass('expanded')) {
            decreaseMiniCart();
        } else if (touchEndY - touchStartY > 50 && !$minicartFlyout.hasClass('expanded')) {
            closeMiniCart();
        } else if (touchEndY - touchStartY <= $('.popover').height()) {
            increaseMiniCart();
        }
    }
    var resetButton = function () {
        var button = document.querySelector('.remove-and-process');
        if (button) {
            var placeholder = document.createElement('div');
            button.parentNode.replaceChild(placeholder, button);
            setTimeout(() => {
                var newButton = button.cloneNode(true);
                placeholder.parentNode.replaceChild(newButton, placeholder);
            }, 1); // Minimal delay to ensure the browser processes the change
        }
    };

    var runA11yAndFocus = function ($dialog) {
        if (!$dialog || !$dialog.length) return;

        var headerText = $.trim($dialog.find('#cart-header-title').text());
        if (headerText) {
            $dialog.attr('aria-label', headerText + ' modal');
        }

        focusHelper.focusWithPolling(function () {
            if (!$dialog.is('[tabindex]')) {
                return $();
            }
            return $dialog;
        }, {
            intervalMs: 100,
            maxAttempts: 20,
            ensureTabindex: false
        });
    };

    var handlePostMiniCart = function (data, self, smoothAnimation) {
        var $popover = $('.minicart .popover');
        var isQuickModalActive = $('.quick-modal.show').length;
        var addToCartButton = $('.add-to-cart');
        var isATC = false;
        var $newProgressBarHtml = null;
        var $currentProgressBarHtml = null;
        $('body').toggleClass('hide-zendesk', true);
        $('body').addClass('no-scroll');
        $('.minicart-overlay').fadeIn();
        // Update aria-expanded state when opening
        $('.minicart-link').attr('aria-expanded', 'true');
        // Hide background content from screen readers to prevent random announcements
        $('#maincontent, .page > footer, .footer').attr('aria-hidden', 'true');
        // Store the minicart button for focus restoration
        if (!lastFocusedElement) {
            lastFocusedElement = $('.minicart-link')[0];
        }
        // var isEmpty = data && data.includes('js-mini-cart-empty-wrapper');
        var isInventoryError = data && data.includes('cart-header inventory-error');
        self.data('requested', false);
        updateMiniCart = false;
        if ($('.minicart').data('pid')) {
            $.spinner().stop();
            $('.minicart').data('pid', '');
            updateMiniCart = true;
        }
        // if (isEmpty) $('.minicart-flyout').addClass('expanded');
        if (smoothAnimation) {
            focusHelper.muteTrigger(addToCartButton);
            $('.minicart .popover .cart').fadeOut(150, function () {
                $popover.empty().append(data);
                $popover.toggleClass('oots-items', isInventoryError);
                $popover.toggleClass('expanded', isInventoryError);
                setTimeout(function () {
                    $popover.find('.cart').fadeIn();
                }, 10);
                setTimeout(function () {
                    $('.mini-cart-page .cart').spinner().stop();
                }, 100);
                setTimeout(function () {
                    resetButton();
                    runA11yAndFocus($popover);
                    focusHelper.unmuteTrigger(addToCartButton);
                }, 150);
                $popover.addClass('show');
                promoProgressBar.initTooltip();
            });
        } else {
            $popover.empty();

            var $newMiniCartHtml = $(data);
            isATC = $newMiniCartHtml.find('.cart-sheet').hasClass('pid');
            if (isATC) {
                $newProgressBarHtml = $newMiniCartHtml.find('.promo-progress-bar-container');
                $currentProgressBarHtml = $('.pre-add-product-promo-progress-bar-container .promo-progress-bar-container');
                promoProgressBar.initATCProgressBar($newProgressBarHtml, $currentProgressBarHtml);
                $newProgressBarHtml.replaceWith($currentProgressBarHtml);
            }
            $popover.append($newMiniCartHtml);

            resetButton();
            $popover.toggleClass('oots-items', isInventoryError);
            $popover.toggleClass('expanded', isInventoryError);
            $popover.addClass('show');
            if (!isQuickModalActive) runA11yAndFocus($popover);
        }

        // setTimeout(function () {
        //     $('.minicart .popover #cart-header-title').attr('tabindex', '-1').focus();
        // }, 350);
        syncProgressBarWidth();
        promoProgressBar.initTooltip();

        setTimeout(function () {
            $('.minicart-flyout .cart-sheet').on('scroll', debounceShadows);
        }, 600);

        $('body').trigger('initRecommendationSlider');

        if (isQuickModalActive) {
            quickView.methods.slideQuickviewOut(false, { suppressRestoreFocus: true });
            if (isATC && !smoothAnimation) {
                $('.quick-modal').on('hidden.bs.modal', function () {
                    promoProgressBar.update($newProgressBarHtml, $currentProgressBarHtml);
                    $('.pre-add-product-promo-progress-bar-container').remove();
                });
            }
        } else {
            runA11yAndFocus($popover);
            if (isATC && !smoothAnimation) {
                setTimeout(function () {
                    promoProgressBar.update($newProgressBarHtml, $currentProgressBarHtml);
                    $('.pre-add-product-promo-progress-bar-container').remove();
                }, 700);
            }
        }

        loadAppleExpress();
        $('.minicart .popover').removeClass('loading').addClass('loaded');
    };

    var debounceFlyout = debounce(toggleFlyout, 50);

    $('body').on('touchstart', '.minicart-flyout', function (e) {
        touchStartY = e.originalEvent.touches[0].clientY;
    });

    $('body').on('touchmove', '.minicart-flyout', function (e) {
        debounceFlyout(e);
    });

    $('body').on('showOotModal', function (e) {
        var self = $(this);
        e.preventDefault();

        var url = $('.minicart').data('action-url');
        url += '?showInventoryError=1';

        if ($('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                $('.minicart .popover').addClass('show');
                $('body').toggleClass('hide-zendesk', true);
                $('body').addClass('no-scroll');
                $('.minicart-overlay').fadeIn();
                $('.minicart-link').attr('aria-expanded', 'true');
                // Hide background content from screen readers
                $('#maincontent, .page > footer, .footer').attr('aria-hidden', 'true');
                // Store the minicart button for focus restoration
                if (!lastFocusedElement) {
                    lastFocusedElement = $('.minicart-link')[0];
                }
                return;
            }

            self.data('requested', true);
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').addClass('show');
                $('body').toggleClass('hide-zendesk', true);
                $('body').addClass('no-scroll');
                $('.minicart-overlay').fadeIn();
                $('.minicart-link').attr('aria-expanded', 'true');
                // Hide background content from screen readers
                $('#maincontent, .page > footer, .footer').attr('aria-hidden', 'true');
                // Store the minicart button for focus restoration
                if (!lastFocusedElement) {
                    lastFocusedElement = $('.minicart-link')[0];
                }
                self.data('requested', false);
                $('.minicart .popover').toggleClass('oots-items', true);
                $('.minicart .popover').toggleClass('expanded', true);
                $('.minicart .popover').append(data);
                updateMiniCart = false;
            });
        } else {
            $.spinner().stop();
            $('.mini-cart-page .cart').spinner().start();
            $.get(url, function (data) {
                handlePostMiniCart(data, self, true);
            });
        }
    });

    $('body').on('click', '.minicart-flyout .pdp-recommendations, .recommendations', function () {
        if ($(window).width() >= utils.breakpoints.md || !$('.minicart-flyout').hasClass('show')) {
            return;
        }

        increaseMiniCart();
    });

    // $('.minicart .popover').on('transitionrun transitionstart', function () {
    //     if (!$('.minicart .popover').hasClass('is-transitioning')) {
    //         $('.minicart .popover').addClass('is-transitioning');
    //     }
    // });

    // $('.minicart .popover').on('transitionend', function () {
    //     if ($('.minicart .popover').hasClass('is-transitioning')) {
    //         $('.minicart .popover').removeClass('is-transitioning');
    //     }
    // });

    $('.minicart').on('click keydown', function (e, eventData) {
        // Store the focused element to restore focus later
        if ($(e.target).closest('.minicart-link').length || $(e.target).hasClass('minicart-link')) {
            lastFocusedElement = $('.minicart-link')[0];
        }

        var isViewBagClick = $(e.target).is('.view-bag-btn') && window.innerWidth >= utils.breakpoints.md;
        // if ($('.minicart .popover').hasClass('is-transitioning') && !isViewBagClick) {
        //     return; // Ignore clicks while transitioning
        // }
        var isAddToCart = eventData ? eventData.isAddToCart : false;

        if (e.type === 'keydown' && e.key !== 'Enter') {
            return; // Ignore other keys
        }
        var pid = $('.minicart').data('pid');

        if (($('.page').data('action') === 'Cart-Show' && !pid) ||
            $(e.target).closest('.cart-recommendations-container').length ||
            $(e.target).closest('.remove-and-process').length ||
            $(e.target).closest('.mini-cart-page-empty').length
        ) {
            return;
        }

        if ($(e.target).is('.checkout-btn')) {
            e.preventDefault();
            return;
        }

        // $(e.target).hasClass('checkout-btn')
        if (e.type !== 'keydown' && (($(e.target).is('a, .continue-shopping-btn') && !$(e.target).hasClass('edit')) && !isViewBagClick)) {
            if ($(e.target).is('.continue-shopping-btn')) e.preventDefault();
            closeMiniCart();
            return;
        }

        // Handle the mobile view case
        if (breakpoints.isMobileView() && ($(e.target).closest('.minicart-link').length || $(e.target).find('.minicart-link').length)) {
            var cartUrl = $('.minicart-link').data('url');
            var emptyCart = $('.minicart-quantity.no-quantity-items').length;
            var isInvenroryError = $('.minicart-link').attr('data-inventory-error') === 'true';
            if (cartUrl && !emptyCart && !isInvenroryError && !pid) {
                window.location.href = cartUrl;
                return;
            }
        }

        var self = $(this);
        if ((!e.target.closest('.popover a') || isViewBagClick) && !pid) {
            e.preventDefault();
        }

        if ($('.search:visible').length === 0 || self.data('requested')) {
            return;
        }
        var url = $('.minicart').data('action-url');
        if (pid) {
            url += '?pid=' + pid;
        }

        if ($('.minicart .popover.show').length === 0 || isViewBagClick || isAddToCart || (pid && $('.quick-view-dialog').is(':visible'))) {
            if (!updateMiniCart && !pid && !(isViewBagClick)) {
                $('.minicart .popover').addClass('show');
                $('body').addClass('no-scroll');
                $('body').toggleClass('hide-zendesk', true);
                $('.minicart-overlay').fadeIn();
                $('.minicart-link').attr('aria-expanded', 'true');
                // Hide background content from screen readers
                $('#maincontent, .page > footer, .footer').attr('aria-hidden', 'true');
                // Store the minicart button for focus restoration
                if (!lastFocusedElement) {
                    lastFocusedElement = $('.minicart-link')[0];
                }
                return;
            }

            if (isViewBagClick) {
                $('.mini-cart-page .cart').spinner().start();
            }
            self.data('requested', true);
            $('.minicart .popover').removeClass('loaded').addClass('loading');
            $.get(url, function (data) {
                handlePostMiniCart(data, self, isViewBagClick);
            });
        }
        // waitForTransitionEnd($('.minicart .popover'), function () {
        //     if ($('.minicart .popover.show').length === 0 || isViewBagClick || (pid && $('.quick-view-dialog').is(':visible'))) {
        //         if (!updateMiniCart && !pid && !(isViewBagClick)) {
        //             $('.minicart .popover').addClass('show');
        //             $('body').addClass('no-scroll');
        //             $('body').toggleClass('hide-zendesk', true);
        //             $('.minicart-overlay').fadeIn();
        //             return;
        //         }

        //         if (isViewBagClick) {
        //             $('.mini-cart-page .cart').spinner().start();
        //         }
        //         self.data('requested', true);
        //         $.get(url, function (data) {
        //             handlePostMiniCart(data, self, isViewBagClick);
        //         });
        //     }
        // });
    });
    // $('body').on('touchstart click', function (e) {
    //     if ($('.minicart').has(e.target).length <= 0 && !$(e.target).is('div.minicart') && !$(e.target).hasClass('checkout-btn')) {
    //         closeMiniCart();
    //     }
    // });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });
    $('body').on('keydown', '.bv-rating-stars-container, .bv-write-review-label', function (e) {
        if (e.key === 'Tab' && e.shiftKey) {
            e.preventDefault();
            const focusableElements = $('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])')
                .filter(':visible');
            const currentIndex = focusableElements.index(this);
            let targetIndex = (currentIndex - 1);
            for (let i = currentIndex - 1; i >= 0; i--) {
                if (focusableElements.eq(i).is('button.add-to-cart:not([data-toggle])') || focusableElements.eq(i).is('a')) {
                    targetIndex = i;
                    break;
                }
            }
            if (targetIndex !== -1) {
                focusableElements.eq(targetIndex).focus();
            }
        }
    });

    $('body').on('keydown', '.collapsible-xl .pdp-recommendations__title, .thumb, .footer-btns a, .cart-continue a, .view-more-btn', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (($(this).hasClass('view-bag-btn') && window.innerWidth >= utils.breakpoints.md) || $(this).hasClass('checkout-btn')) return;
            if ($(this).hasClass('continue-shopping-btn')) {
                closeMiniCart();
            } else if ($(this).is('a')) {
                window.location.href = $(this).attr('href');
            } else {
                $(this).trigger('click');
            }
        }
    });

    $(document).ready(function () {
        setTimeout(function () {
            $('.cart-recommendations-container .js-image-wrapper.tab-1').attr('tabindex', '-1');
        }, 3000);
    });

    $(window).on('beforeunload', function (e) {
        if ($('.remove-product.dismiss-btn:visible').length) {
            $('.remove-product.dismiss-btn:visible').trigger('click');
            e.preventDefault();
            // eslint-disable-next-line no-param-reassign
            e.returnValue = '';
            return '';
        }
        return undefined;
    });

    $('body').on('keydown', '.minicart .minicart-flyout', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '.minicart .minicart-flyout'
        };
        focusHelper.setTabNextFocus(focusParams);
    });
};

